module.exports = require('jadelet').exec(["input",{"value":{"bind":"value"},"type":{"bind":"type"}},[]]);